import type { MessageKey } from '../i18n/messages';
import { notReadyCode } from './answer';

/**
 * The words for a sent order's discount change the store refused (UC-35, T14):
 * paid meanwhile, the discount removed from the list, the store not ready, or
 * FORBIDDEN, which is a cashier's change of a discount only a manager gives or
 * takes off a sent order (UC-35.R9). Any other refusal asks for another try.
 */
export function discountRefusalMessage(code: string): MessageKey {
	if (code === 'ALREADY_PAID') return 'ordersPaidAlready';
	if (code === 'DISCOUNT_UNAVAILABLE' || code === 'NOT_FOUND') return 'discountRemoved';
	if (code === 'FORBIDDEN') return 'discountManagerOnly';
	if (notReadyCode(code)) return 'tillNotReady';
	return 'ordersFailed';
}
